/**
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 * !!  WARNING: Do NOT edit this file!  !!
 * !!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!!
 *
 * Foundation components are not intended to be edited to
 * satisfy specific use cases. If you would like to propose
 * a change to this component, please reach out to a
 * frontend engineer.
 *
 * @author Asa Ayers <asa.ayers@hellosign.com>
 * @author Nathan Buchar <nathan.buchar@hellosign.com>
 */

import React from 'react';
import TetherComponent from 'react-tether';
import TooltipUI, { TooltipPoint, ArrowDirection, TooltipUIProps } from './tooltip-ui';

export { TooltipUI, TooltipPoint, ArrowDirection };

// Infer TetherComponent props because they were not
// exported >:(
type TetherProps = TetherComponent extends React.Component<infer P> ? P : never;

type Props = Omit<TetherProps, 'attachment'> & {
  className?: string

  // TypeScript didn't like me using the ref on a <button, so I had to change it
  // from RefObjet<HTMLElement> to RefObject<any>
  children: (ref: React.RefObject<any /* HTMLElement */>) => React.ReactNode

  content: React.ReactNode
  kind?: TooltipUIProps['kind']

  // This prop is required by TetherComponent, but we
  // define a default value for it below so let's make it
  // optional.
  attachment?: TetherProps['attachment']
}

function Tooltip({
  className,
  children,
  content,
  kind,

  // react-tether defaults and props
  attachment = 'bottom center',
  constraints = [
    {
      to: 'scrollParent',
      attachment: 'together',
    },
  ],
  ...rest
}: Props) {
  return (
    <TetherComponent
      {...rest}
      attachment={attachment}
      constraints={constraints}
      renderTarget={children}
      renderElement={(ref) => (
        <TooltipUI ref={ref} kind={kind} className={className}>
          {content}
        </TooltipUI>
      )} />
  );
}

export default Tooltip;
